import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import companies from "../../services/companies.js";

class InvoiceController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout,
    $location,
    $scope
  ) {
    this.name = "invoice";
    $localStorage.activeStateName = "invoice";
    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.query = "";
    this.$common = CommonService;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.isPrivate = false;
    this.isPreferred = false;
    this.remain_loading_count = 1;
    this.event = {};
    this.teamsPostedTo = [];
    this.acceptedApplicants = [];
    this.currentUser = this.$auth.getUserData();
    this.events = [];
    this.isdp = false;
    this.target1Options = {
      filename: "target1.png",
      downloadText: "Download me",
      cancelText: "Close it!",
    };

    var _this = this;

    _this.isDirectPayReceipt();

    if (this.$location.$$search.eventId) {
      this.$events.getEventByIdTrimmedInvoice(this.$location.$$search.eventId).then(function (data) {
        _this.event = data.data;
        _this.jobbleDuration = data.data.subEvents[0].deduppedJobbles[0].jobbleDurationInMinutes;
        _this.$security.getInvoice(_this.$stateParams.invoiceId, _this.$location.$$search.eventId).then(function (response) {
          console.log("invoice response");
          console.dir(response);
          _this.remain_loading_count--;
          response.data.sort(function (a, b) {
            if (a.payedUser.lastName < b.payedUser.lastName) return -1;
            if (a.payedUser.lastName > b.payedUser.lastName) return 1;
            return 0;
          });
          _this.invoice = response.data;
          _this.displayTotals();
        });
      });
    } else {
      _this.$security.getInvoice(_this.$stateParams.invoiceId, _this.$location.$$search.eventId).then(function (response) {
        _this.remain_loading_count--;
        _this.invoice = response.data;
        _this.displayTotalsDP();
      });
    }

    _this.formatNumber();
  }

  isDirectPayReceipt() {
    var _this = this;
    if (this.$location.$$search.dp) {
      _this.isdp = true;
    }
  }

  formatNumber() {
    var _this = this;
  }

  displayHours(jobble) {
    var _this = this;
    if (jobble.actualMinutesWorked !== null) {
      var hours = Math.floor(jobble.actualMinutesWorked / 60);
      return hours;
    } else {
      //var diffinmin = moment(jobble.endTime).diff(moment(jobble.startTime), 'minutes');
      var hours = Math.floor(_this.jobbleDuration / 60);

      //console.dir(hours);
      return hours;
    }
  }

  displayMins(jobble) {
    var _this = this;
    if (jobble.actualMinutesWorked !== null) {
      var hours = Math.floor(jobble.actualMinutesWorked / 60);
      var leftovers = jobble.actualMinutesWorked - hours * 60;
      var min = leftovers % 60;
      return min;
    } else {
      var hours = Math.floor(_this.jobbleDuration / 60);
      var leftovers = _this.jobbleDuration - hours * 60;
      var min = leftovers % 60;
      return min;
    }
  }

  displayTotals() {
    var _this = this;

    _this.totals = {};

    var subtotal = 0;
    var total = 0;

    try {
      _this.invoice.forEach(function (iv) {
        subtotal = subtotal + iv.amount;
        total = total + iv.amountCompany;
      });
    } finally {
      _this.totals.subtotal = subtotal;
      _this.totals.total = total;

      return _this.totals;
    }
  }

  displayTotalsDP() {
    var _this = this;

    _this.totals = {};

    var subtotal = 0;
    var total = 0;

    console.log("invoice");
    console.dir(_this.invoice);

    _this.totals.subtotal = _this.invoice.amount;
    _this.totals.total = _this.invoice.amountCompany;

    return _this.totals;
  }

  pdf() {
    var _this = this;
    html2canvas(document.getElementById("receipt-data")).then(function (canvas) {
      let imgData = canvas.toDataURL("image/png");
      let doc = new jsPDF("p", "mm");
      doc.addImage(imgData, "PNG", 10, 10, 180, 150);
      doc.save("sample-file.pdf");
    });
  }

  specialElementHandlers() {
    var _this = this;
  }
}

InvoiceController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
  "$location",
  "$scope",
];

export default InvoiceController;



// WEBPACK FOOTER //
// ./client/app/components/invoice/invoice.controller.js